export function mapNonMtlsUrlToMtls(originalUrl: string): string | null {
	const mappings: Array<[string | undefined, string | undefined]> = [
		[WEBPACK_BASE_ADDRESS, WEBPACK_MTLS_BASE_ADDRESS],
		[WEBPACK_BASE_PROXY_ADDRESS, WEBPACK_MTLS_BASE_PROXY_ADDRESS],
		[WEBPACK_WEBSITE_URL, WEBPACK_MTLS_INTERNAL_API_ADDRESS],
		[CasinoApiAddress, WEBPACK_MTLS_CASINO_API_ADDRESS],
	];

	for (const [nonMtlsBase, mtlsBase] of mappings) {
		if (nonMtlsBase && mtlsBase && originalUrl.startsWith(nonMtlsBase)) {
			return originalUrl.replace(nonMtlsBase, mtlsBase);
		}
	}

	return null;
}
